<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><em class="fas fa-stamp"></em></span>{{ "CustomerSignatureSampleStamp.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [(selected)]="isSearchFormOpen">
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'CustomerSignatureSampleStamp.Form.Facility' | translate }}</label>
              <div class="item">
                <laas-facility-dropdown 
                  formControlName="facility" 
                  [isSingle]="true" 
                  (onOptionDataChange)="optionsDataOnChange($event, 'facility')">
                </laas-facility-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'CustomerSignatureSampleStamp.Form.OrgId' | translate }}</label>
              <laas-multiSelect [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}" filterBy="label" [(ngModel)]="searchParams.orgId"
                [options]="orgIdOptions" [virtualScroll]="true" [virtualScrollItemSize]="40" formControlName="orgId"></laas-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'CustomerSignatureSampleStamp.Form.ConsigneeKey' | translate }}</label>
              <laas-customer-dropdown formControlName="consigneeKey" [showToggleAll]="false" [isMultiple]="true" [showLabel]="false" [divClass]="'field'"></laas-customer-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'CustomerSignatureSampleStamp.Form.Brand' | translate }}</label>
              <laas-multiSelect [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}" 
                filterBy="label" [options]="brandOptions" [virtualScroll]="true" 
                [virtualScrollItemSize]="40" formControlName="brand"></laas-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'CustomerSignatureSampleStamp.Form.InternalBrand' | translate }}</label>
              <laas-multiSelect [filter]="true" placeholder="{{ 'Common.DropDown.Select' | translate}}" 
                filterBy="label" [options]="internalBrandOptions" [virtualScroll]="true" 
                [virtualScrollItemSize]="40" formControlName="internalBrand"></laas-multiSelect>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Search' | translate}}" (click)="searchBtnClick()"></button>
              <button pButton label="{{ 'Common.Button.Reset' | translate}}" class="p-button-secondary ml-2" (click)="resetBtnClick()"></button>
              <p-inputSwitch formControlName="chooseOnlyNone" class="ml-2" [(ngModel)]="searchParams.chooseOnlyNone" ></p-inputSwitch>
              <label class="ml-2">{{ 'CustomerSignatureSampleStamp.Form.OnlyNullChopSign' | translate }}</label>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table
        #dataTable
        [(selectedRows)]="selectedRows"
        (setPageSize)="setPageSize($event)"
        [lazy]="true"
        [dataKey]="'orgId'"
        (tableOnPage)="tablePageChange($event)"
        (tableOnSort)="tableSort($event)"
        [rows]="pageInfo.pageSize"
        [totalRecords]="pageInfo.totalRecords"
        [tableKey]="preferenceKey"
        [value]="tableValue"
        [defaultColumns]="tableColumns"
        [loading]="isLoading">
        <ng-template
          pTemplate="body"
          let-rowData
          let-columns="columns"
          >
            <td *ngFor="let col of columns">
              <ng-container [ngSwitch]="col.field">
                <div *ngSwitchCase="'type'">
                  <div class="overflow-text">{{ rowData[col.field] | optionsMapping: addressTypeOptions | replaceNullWith:'-'}}</div>
                </div>
                <div *ngSwitchCase="'sn'">
                  <div *ngIf="rowData.sn then snNotNull else snNull"></div>
                  <ng-template #snNotNull>
                    <img alt="{{ 'CustomerSignatureSampleStamp.Table.Column.ChopSignSample' | translate }}" (click)="showDialog(getImgUrl(rowData.sn))" style="width: 100%;"  [src]="getImgUrl(rowData.sn) | image | async" />
                  </ng-template>
                  <ng-template #snNull>
                    <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                  </ng-template>
                </div>

                <ng-container *ngSwitchCase="'consigneeKey'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:consigneeKeyOptions | replaceNullWith:'-' }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <ng-container [ngSwitch]="col.dataType">
                    <ng-container *ngSwitchCase="'date'">
                      <div class="overflow-text">{{ rowData[col.field] | date: "yyyy-MM-dd HH:mm": this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </td>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
  <p-dialog [(visible)]="isVisible" header="{{ 'CustomerSignatureSampleStamp.Table.Column.ChopSignSample' | translate }}" appendTo="body" [modal]="true" [draggable]="false"
  [resizable]="false" [dismissableMask]="true" [style]="{ width: '40%' }" >
    <img style="width: 100%;"  [src]="imgUrl | image | async" alt="ChopSignSample" />
  </p-dialog>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
